"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFullStop = exports.normalise = exports.escapeRegExp = exports.convertToTitleCase = exports.convertToPascal = exports.convertToCamel = exports.convertToKebab = exports.generateUniqueId = exports.titleCaseToSentenceCase = exports.camelCaseToKebabCase = exports.kebabCaseToCamelCase = exports.sentenceCaseToTitleCase = exports.sentenceCaseToSnakeCase = exports.sentenceCaseToCamelCase = exports.snakeCaseToSentenceCase = exports.camelCaseToSentenceCase = void 0;
function camelCaseToSentenceCase(str) {
    const result = str.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}
exports.camelCaseToSentenceCase = camelCaseToSentenceCase;
function snakeCaseToSentenceCase(str) {
    const result = str.replace(/_/g, " ");
    return result.charAt(0).toUpperCase() + result.slice(1);
}
exports.snakeCaseToSentenceCase = snakeCaseToSentenceCase;
function sentenceCaseToCamelCase(str) {
    const result = str.replace(/\s(.)/g, function (_, group1) {
        return group1.toUpperCase();
    });
    return result.charAt(0).toLowerCase() + result.slice(1);
}
exports.sentenceCaseToCamelCase = sentenceCaseToCamelCase;
function sentenceCaseToSnakeCase(str) {
    const result = str.replace(/\s/g, "_");
    return result.toLowerCase();
}
exports.sentenceCaseToSnakeCase = sentenceCaseToSnakeCase;
function sentenceCaseToTitleCase(str) {
    return str.replace(/\b\w/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1);
    });
}
exports.sentenceCaseToTitleCase = sentenceCaseToTitleCase;
function kebabCaseToCamelCase(str) {
    return str.replace(/-([a-z])/g, function (_, group1) {
        return group1.toUpperCase();
    });
}
exports.kebabCaseToCamelCase = kebabCaseToCamelCase;
function camelCaseToKebabCase(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
exports.camelCaseToKebabCase = camelCaseToKebabCase;
function titleCaseToSentenceCase(str) {
    var _a;
    const words = (_a = str.match(/[A-Za-z][a-z]*/g)) !== null && _a !== void 0 ? _a : [];
    return words.map((word) => word.toLowerCase()).join(' ');
}
exports.titleCaseToSentenceCase = titleCaseToSentenceCase;
function generateUniqueId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
exports.generateUniqueId = generateUniqueId;
;
/**
 * Converts any string to Kebab Case
 */
const convertToKebab = (str) => {
    return str === null || str === void 0 ? void 0 : str.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+|_+/g, '-').toLowerCase();
};
exports.convertToKebab = convertToKebab;
/**
 * Converts any string to camelCase
 */
const convertToCamel = (str) => {
    return str === null || str === void 0 ? void 0 : str.split(/\s+|_+|-+/g).map((part, i) => !i
        ? part.toLowerCase()
        : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join('');
};
exports.convertToCamel = convertToCamel;
/**
 * Converts any string to Pascal Case
 */
const convertToPascal = (str) => {
    return str === null || str === void 0 ? void 0 : str.split(/\s+|_+|-+/g).map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join('');
};
exports.convertToPascal = convertToPascal;
const convertToTitleCase = (str) => {
    return str === null || str === void 0 ? void 0 : str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};
exports.convertToTitleCase = convertToTitleCase;
/**
 * Escape RegExp restricted characters
 */
const escapeRegExp = (str) => {
    return str === null || str === void 0 ? void 0 : str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
exports.escapeRegExp = escapeRegExp;
/**
 * Normalises a value to convert to string, remove spaces, convert to lowercase and trim any whitespace.
 * @param str
 */
const normalise = (str) => { var _a; return (_a = `${str}`) === null || _a === void 0 ? void 0 : _a.replace(/ /g, '').toLowerCase().trim(); };
exports.normalise = normalise;
const addFullStop = (str) => str.charAt(str.length - 1) === '.' ? str : `${str}.`;
exports.addFullStop = addFullStop;
